import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorService } from 'src/app/core/services/error.service';

@Component({
  selector: 'app-input-toggle',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatInputModule,
  ],
  templateUrl: './input-toggle.component.html',
  styleUrl: './input-toggle.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputToggleComponent {
  @Input() name: string = '';
  @Input() label?: string;
  @Input() icon?: string;
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() labelError?: string;
  @Input() class: string = '';

  constructor(
    private errorService: ErrorService
  ) { }

  hasError() {
    return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  }

  error() {
    const errors = Object.entries(
      this.form.get(this.name)?.errors || {}
    );
    return this.errorService.getErrorValidationMessage(this.labelError ?? this.label ?? this.name, errors);
  }
}
